import { configureStore } from '@reduxjs/toolkit';
import sharedStateReducer from './sharedStateSlice';

const store = configureStore({
  reducer: {
    sharedState: sharedStateReducer,
  },
});

export default store;
